module.exports = __webpack_public_path__ + "img/xj1.dab8eb8d.png";